const endpoints = {
  loadFile: 'api/v2/users/user-id/files',
}

export default endpoints
